import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import {
  sendNotification,
  getStats,
  rowSelect,
} from '../../store/action/patient.action'
import { Row, Col, Button, Modal, Card, Form, Input, message } from 'antd'
import _ from 'lodash'
import '../../css/patient.scss'

var form = undefined

const PatientNotify = (props) => {
  var handleCancel = () => {
    form && form.resetFields()
    props.onClose()
  }

  var handleOk = () => {
    form.validateFields().then((values) => {
      console.log(values)
      props
        .sendNotification({
          patientids: props.patientids,
          header: values.header,
          message: values.message,
          customerid: props.customer?._id,
        })
        .then((data) => {
          form && form.resetFields()
          props.onSuccess(data)
        })
    })
  }

  var renderPatients = () => {
    return (
      props.selectedPatients?.row &&
      props.selectedPatients?.row.map((patient, index) => {
        return (
          <Row className='notifyRow'>
            {_.upperFirst(patient.firstname) +
              ' ' +
              _.upperFirst(patient.lastname)}
          </Row>
        )
      })
    )
  }

  var renderBody = () => {
    return (
      <Card bordered={false}>
        <Row>
          <Col hidden={!props.showPatientsList} flex={'250px'}>
            <Row>
              <h3>Patients</h3>
            </Row>
            {renderPatients()}
          </Col>
          <Col flex={'auto'}>
            <Form
              ref={(e) => (form = e)}
              name='normal_login'
              layout={'vertical'}
              // initialValues={props.filters}
              labelCol={{ span: 3 }}
            >
              <Form.Item
                name='header'
                label='Title'
                rules={[
                  {
                    required: true,
                    message: 'Please input Title!',
                  },
                ]}
              >
                <Input placeholder='Title' />
              </Form.Item>
              <Form.Item
                name='message'
                label='Text'
                rules={[
                  {
                    required: true,
                    message: 'Please confirm your Text!',
                  },
                ]}
              >
                <Input.TextArea allowClear rows={4} />
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </Card>
    )
  }

  return (
    <Modal
      className={'filterModal'}
      visible={props.visible}
      closable={false}
      maskClosable={false}
      onCancel={handleCancel}
      onOk={handleOk}
      width={'70%'}
      okText={'Send'}
    >
      {renderBody()}
    </Modal>
  )
}

PatientNotify.propTypes = {
  sendNotification: PropTypes.func.isRequired,
  getStats: PropTypes.func.isRequired,
  selectedPatients: PropTypes.object,
  customer: PropTypes.object,
  stats: PropTypes.object,
  patientids: PropTypes.array,
  showPatientsList: PropTypes.bool,
  onClose: PropTypes.func,
  onSuccess: PropTypes.func,
  visible: PropTypes.bool,
}

const mapStateToProps = (state) => {
  return {
    selectedPatients: state.patient?.selectedPatients,
    customer: state.profile.customer,
    error: state.patient.notifyError,
    message: state.patient.notifyMessage,
    stats: state.patient.stats,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    sendNotification: (params) => dispatch(sendNotification(params)),
    getStats: () => dispatch(getStats()),
    resetSelectedPatients: () => dispatch(rowSelect({})),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PatientNotify)
